import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const SwitchBlockConfigSchema = z.object({
  fn: z.string().min(1, {
    message: 'Script is required.',
  }),
  switchResultType: z.string(),
});
export type SwitchBlockConfig = z.infer<typeof SwitchBlockConfigSchema>;

export const SwitchBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Switch),
  config: SwitchBlockConfigSchema,
});
export type SwitchBlock = z.infer<typeof SwitchBlockSchema>;
